module.exports = __webpack_public_path__ + "static/media/deco.e0e108f3.mp3";